import React from 'react';
import { Gift } from '@wix/wix-ui-icons-common/lazy';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { ExperimentSpecs } from '../../constants';
import { PERCEPTION_CONTENT } from '../../pricingPerception';
import { BaseVoucherBanner } from './VoucherBanner';
import { useIsMobile } from '../../hooks/useIsMobile';
export const AnonymousVoucherBanner = _ref => {
  var _getPremiumEssentials, _getPremiumEssentials2;
  let {
    isResultsPageOptimizations = false
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const {
    t: tSuite
  } = DomainSearchSuiteModule.internals.useTranslations();
  const isMatchCycle = !!((_getPremiumEssentials = getPremiumEssentialsSafe()) != null && (_getPremiumEssentials = _getPremiumEssentials.experiments) != null && _getPremiumEssentials[ExperimentSpecs.MatchDomainCycleToPremiumCycle]);
  const isMobile = useIsMobile();
  const isPerception = Boolean((_getPremiumEssentials2 = getPremiumEssentialsSafe()) == null || (_getPremiumEssentials2 = _getPremiumEssentials2.experiments) == null ? void 0 : _getPremiumEssentials2[ExperimentSpecs.PricingPerceptionFirstYear]);
  let bannerContent;
  if (isPerception && !isMobile) {
    bannerContent = tSuite(PERCEPTION_CONTENT.anonymous.banner);
  } else if (isResultsPageOptimizations) {
    bannerContent = isMobile ? tSuite('domains_search_suite.storefront.optimizations.voucher_banner') : tSuite('domains_search_suite.anon_storefront_results.optimizations.initial_vs_renewal.banner');
  } else if (isMatchCycle) {
    bannerContent = isMobile ? t('domain_search_gate.mobile.banner.promo.no_voucher.match_cycle.title') : t('domain_search_gate.storefront_results.match_cycle.banner');
  } else {
    bannerContent = isMobile ? t('domain_search_suite.mobile.banner.promo.no_voucher.title') : t('domain_search_gate.storefront_results.free_one_year.banner');
  }
  return /*#__PURE__*/React.createElement(BaseVoucherBanner, {
    icon: /*#__PURE__*/React.createElement(Gift, null),
    content: bannerContent
  });
};
//# sourceMappingURL=AnonymousVoucherBanner.js.map